// extracted by mini-css-extract-plugin
module.exports = {"rowColumns":"formPesquisa_rowColumns__GjErZ","columnLabel":"formPesquisa_columnLabel__2nU3c","label":"formPesquisa_label__11xRv"};